import "./SomethingWentWrongPage.scss"

import React from "react"
import { Container, Nav, Navbar } from "react-bootstrap"
import { Link } from "react-router-dom"

import { useConfig } from "../../../utils/hook"
import Button from "../../atoms/Button"
import SvgIcon from "../../atoms/SvgIcon"

const SomethingWentWrongPage = () => {
  const config = useConfig()

  return (
    <div>
      <SvgIcon icon="test" style={{ width: 100 }} />
      <Navbar className="header-container header-404" expand="lg" variant="light" sticky="top">
        <Nav className="mr-auto ml-3">
          <Link to="/">
            <img
              src={config.REACT_APP_LOGO_IMAGE_LIGHT_THEME}
              alt=""
              width={config.REACT_APP_LOGO_IMAGE_WIDTH}
              height={config.REACT_APP_LOGO_IMAGE_HEIGHT}
            />
          </Link>
        </Nav>
      </Navbar>
      <Container className="d-flex flex-column justify-content-center container-404">
        <img src="/images/not-found.png" className="image-404" />
        <div className="text-404">
          <h1>The page you are looking for is not found.</h1>
          <h3>The link you followed may be broken or the page may have been removed.</h3>
          <Link to="/">
            <Button margin="50px auto 0 auto">Back to home</Button>
          </Link>
        </div>
      </Container>
    </div>
  )
}

export default SomethingWentWrongPage
